export const getShipmentListTab = (initialFilter = {}) => {
  const today = new Date().toISOString().split('T')[0];

  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + 1);
  const nextDayStr = nextDay.toISOString().split('T')[0];

  return {
    field: 'preset',
    isPreset: true,
    defaultTab: 'new',
    tabs: [
      {
        key: 'new',
        label: 'New',
        preset: {
          ...initialFilter,
          shipment_status: ['created', 'picking', 'picked'],
        },
      },
      {
        key: 'packed',
        label: 'Packed',
        preset: {
          ...initialFilter,
          shipment_status: ['packed'],
        },
      },
      {
        key: 'ready_to_ship',
        label: 'Ready To Ship',
        preset: {
          ...initialFilter,
          shipment_status: ['ready_to_ship'],
        },
      },
      {
        key: 'all',
        label: 'All',
        preset: {
          ...initialFilter,
          shipment_status: [
            'created',
            'picking',
            'picked',
            'sidelined',
            'packed',
            'ready_to_ship',
            'added_to_manifest',
            'dispatched',
            'delivered',
            'return_acknowledged',
            'returned',
          ],
          created_after: `${today}T05:30:00`,
          created_before: `${nextDayStr}T05:30:00`,
        },
      },
    ],
  };
};
